import { render, staticRenderFns } from "./DeviceReginSlide.vue?vue&type=template&id=4e7d0016&scoped=true&"
import script from "./DeviceReginSlide.vue?vue&type=script&lang=js&"
export * from "./DeviceReginSlide.vue?vue&type=script&lang=js&"
import style0 from "./DeviceReginSlide.vue?vue&type=style&index=0&id=4e7d0016&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7d0016",
  null
  
)

component.options.__file = "DeviceReginSlide.vue"
export default component.exports